import { MenuOutlined, LinkedinFilled, GithubFilled, MailOutlined } from "@ant-design/icons";
import { Button, Drawer } from "antd";
import { useState } from "react";



interface menuItem {
    label: string;
    key: string;
    link: string;
}

interface HamNavBarProps {
    menuItems: menuItem[];
}

export function HamNavBar({ menuItems }: HamNavBarProps) {
    const [open, setOpen] = useState<boolean>(false);
    
    function handleMenuOpen() {
        setOpen(true);
    }
    
    return (
        <>
            <Button type="link" icon={<MenuOutlined className="text-black"/>} onClick={handleMenuOpen}/>
            <Drawer
                open={open}
                onClose={() => setOpen(false)}
                width={400}
            >
                <div className="flex flex-col h-full">
                <div className="flex flex-col space-y-8 text-center text-2xl">
                    {menuItems.map(item => 
                        <a className="font-dmsans hover:text-red-600" href={item.link} onClick={() => setOpen(false)}>{item.label}</a>
                    )}
                </div>
                <div className="flex justify-center mt-auto space-x-8">
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://www.linkedin.com/in/chaunguyen844/" target="_blank" rel="noopener noreferrer">
                        <LinkedinFilled style={{ fontSize: '20px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="https://github.com/chaung844" target="_blank" rel="noopener noreferrer">
                        <GithubFilled style={{ fontSize: '20px' }}/>
                    </a>
                    <a className="border-none shadow-none text-gray-800 hover:text-red-600" href="mailto:nguye2cu@mail.uc.edu">
                        <MailOutlined style={{ fontSize: '20px' }}/>
                    </a>
                </div>
                </div>
            </Drawer>
        </>
    )
}